import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const LmCustomBuiltLlms = () => {
    return (
        <div className='row pt-20 px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`Custom-built LLMs`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-5 pe-15 m-auto'>
                    <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 ps-0" style={{}} />
                </div>
                <div className='col-md-7 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                With our deep expertise, we can also build or retrain your LLMs. 
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Leverage our skills and expertise to shorten your time to go to market.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {LmCustomBuiltLlms}